var map = {
	"./assets/icons/Gpay.svg": [
		3889,
		3889
	],
	"./assets/icons/angel.svg": [
		3184,
		3184
	],
	"./assets/icons/arrow-right.svg": [
		1633,
		1633
	],
	"./assets/icons/bag.svg": [
		582,
		582
	],
	"./assets/icons/bear.svg": [
		5617,
		5617
	],
	"./assets/icons/bin.svg": [
		9956,
		9956
	],
	"./assets/icons/calendar.svg": [
		6467,
		6467
	],
	"./assets/icons/cart.svg": [
		8126,
		8126
	],
	"./assets/icons/coffee.svg": [
		3819,
		3819
	],
	"./assets/icons/cog-white.svg": [
		2890,
		2890
	],
	"./assets/icons/compas.svg": [
		7704,
		7704
	],
	"./assets/icons/consultation.svg": [
		721,
		721
	],
	"./assets/icons/cross-small-w.svg": [
		8454,
		8454
	],
	"./assets/icons/cross-small.svg": [
		1700,
		1700
	],
	"./assets/icons/cross.svg": [
		9392,
		9392
	],
	"./assets/icons/cz.svg": [
		3641,
		3641
	],
	"./assets/icons/dekujeme.svg": [
		5460,
		5460
	],
	"./assets/icons/delivery.svg": [
		5359,
		5359
	],
	"./assets/icons/dropdown-arrow.svg": [
		2038,
		2038
	],
	"./assets/icons/edit.svg": [
		7746,
		7746
	],
	"./assets/icons/education.svg": [
		4426,
		4426
	],
	"./assets/icons/eye-closed.svg": [
		6081,
		6081
	],
	"./assets/icons/eye.svg": [
		7489,
		7489
	],
	"./assets/icons/facebook.svg": [
		9580,
		9580
	],
	"./assets/icons/favicon.svg": [
		8717,
		8717
	],
	"./assets/icons/fb.svg": [
		4957,
		4957
	],
	"./assets/icons/flag.svg": [
		2748,
		2748
	],
	"./assets/icons/fork.svg": [
		1062,
		1062
	],
	"./assets/icons/globe.svg": [
		5237,
		5237
	],
	"./assets/icons/grid.svg": [
		1861,
		1861
	],
	"./assets/icons/health-first.svg": [
		9115,
		9115
	],
	"./assets/icons/heart-empty.svg": [
		3960,
		3960
	],
	"./assets/icons/heart.svg": [
		3845,
		3845
	],
	"./assets/icons/home.svg": [
		621,
		621
	],
	"./assets/icons/hours.svg": [
		1770,
		1770
	],
	"./assets/icons/iPay.svg": [
		4356,
		4356
	],
	"./assets/icons/ig.svg": [
		8028,
		8028
	],
	"./assets/icons/info.svg": [
		1561,
		1561
	],
	"./assets/icons/instagram.svg": [
		1816,
		1816
	],
	"./assets/icons/loading.svg": [
		3479,
		3479
	],
	"./assets/icons/lock.svg": [
		8308,
		8308
	],
	"./assets/icons/mail.svg": [
		5348,
		5348
	],
	"./assets/icons/map.svg": [
		3306,
		3306
	],
	"./assets/icons/mastercard.svg": [
		280,
		280
	],
	"./assets/icons/menu.svg": [
		9251,
		9251
	],
	"./assets/icons/messenger.svg": [
		1244,
		1244
	],
	"./assets/icons/minus.svg": [
		8405,
		8405
	],
	"./assets/icons/mobile-logo.svg": [
		8667,
		8667
	],
	"./assets/icons/navigate.svg": [
		5863,
		5863
	],
	"./assets/icons/person.svg": [
		1947,
		1947
	],
	"./assets/icons/phone.svg": [
		3429,
		3429
	],
	"./assets/icons/pin.svg": [
		3997,
		3997
	],
	"./assets/icons/plant.svg": [
		2009,
		2009
	],
	"./assets/icons/play-full.svg": [
		2247,
		2247
	],
	"./assets/icons/play.svg": [
		2,
		2
	],
	"./assets/icons/plus.svg": [
		4608,
		4608
	],
	"./assets/icons/quality.svg": [
		8684,
		8684
	],
	"./assets/icons/question.svg": [
		5393,
		5393
	],
	"./assets/icons/quote.svg": [
		833,
		833
	],
	"./assets/icons/row.svg": [
		2652,
		2652
	],
	"./assets/icons/satisfaction.svg": [
		7217,
		7217
	],
	"./assets/icons/search.svg": [
		7737,
		7737
	],
	"./assets/icons/serafin-logo.svg": [
		5826,
		5826
	],
	"./assets/icons/smartphone.svg": [
		8317,
		8317
	],
	"./assets/icons/star-empty.svg": [
		5554,
		5554
	],
	"./assets/icons/star-half.svg": [
		4089,
		4089
	],
	"./assets/icons/star.svg": [
		8752,
		8752
	],
	"./assets/icons/store.svg": [
		9666,
		9666
	],
	"./assets/icons/tea.svg": [
		5214,
		5214
	],
	"./assets/icons/tick.svg": [
		7277,
		7277
	],
	"./assets/icons/tradition.svg": [
		2663,
		2663
	],
	"./assets/icons/twisto.svg": [
		6474,
		6474
	],
	"./assets/icons/twitter.svg": [
		6169,
		6169
	],
	"./assets/icons/upload.svg": [
		2693,
		2693
	],
	"./assets/icons/visa.svg": [
		7837,
		7837
	],
	"./assets/icons/wifi.svg": [
		5111,
		5111
	],
	"./assets/icons/www.svg": [
		443,
		443
	],
	"./assets/icons/yt.svg": [
		7684,
		7684
	],
	"./assets/img/cafe_inverted.svg": [
		6873,
		6873
	],
	"./assets/img/catering/Arrow.svg": [
		4763,
		5603
	],
	"./assets/img/catering/Event1.svg": [
		4104,
		4104
	],
	"./assets/img/catering/Event2.svg": [
		79,
		79
	],
	"./assets/img/catering/Facebook_logo.svg": [
		2800,
		2800
	],
	"./assets/img/catering/Instagram_logo.svg": [
		3067,
		3067
	],
	"./assets/img/catering/Kongres.svg": [
		7063,
		9807
	],
	"./assets/img/catering/Svatba.svg": [
		1296,
		1296
	],
	"./assets/img/catering/Twitter_logo.svg": [
		1753,
		1753
	],
	"./assets/img/catering/Twittter_logo.svg": [
		7630,
		7630
	],
	"./assets/img/catering/cat_logo.svg": [
		1857,
		1857
	],
	"./assets/img/catering/cat_new_logo.svg": [
		8909,
		8909
	],
	"./assets/img/catering/catering_big_logo.svg": [
		9384,
		9384
	],
	"./assets/img/catering/catering_logo.svg": [
		2553,
		2553
	],
	"./assets/img/catering/catering_logo_footer.svg": [
		5472,
		5472
	],
	"./assets/img/catering/catering_new_one_logo.svg": [
		9672,
		9672
	],
	"./assets/img/catering/modni_prehlidka.svg": [
		3424,
		3424
	],
	"./assets/img/catering/pink_cafe_logo.svg": [
		9638,
		9638
	],
	"./assets/img/dekujeme-full.svg": [
		7830,
		7830
	],
	"./assets/img/dekujeme-icon.svg": [
		7872,
		7872
	],
	"./assets/img/libra_signature.svg": [
		3279,
		3279
	],
	"./assets/img/logo.svg": [
		9250,
		9250
	],
	"./assets/img/logo_w.svg": [
		3384,
		3384
	],
	"./assets/img/obedove-menu.svg": [
		5890,
		5890
	],
	"./assets/img/obedovemenu.svg": [
		7486,
		7486
	],
	"./assets/img/overlogo.svg": [
		9884,
		9884
	],
	"./assets/img/signatures/kosvanec.svg": [
		641,
		641
	],
	"./assets/img/signatures/libra.svg": [
		9911,
		9911
	],
	"./assets/img/snidane.svg": [
		7596,
		7596
	],
	"./assets/img/snidane_Cz.svg": [
		7094,
		7094
	],
	"./assets/img/snidane_outline.svg": [
		9696,
		9696
	],
	"./assets/img/snidanovemenu.svg": [
		3524,
		3524
	],
	"./assets/img/tomaskosvanec.svg": [
		7569,
		7569
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 6848;
module.exports = webpackAsyncContext;